<template>
  <div v-loading="loading">
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 经营数据 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <div style="padding: 10px 20px">
        <el-form
          ref="formBatchExport"
          :size="$xUISize"
          :model="batchExportModel"
          :rules="batchExportRules"
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item label="门店仓库">
            <customer-store-select
              :defaultFirst="true"
              style="width: 180px"
              v-model="storeGuid"
              placeholder="门店"
            />
          </el-form-item>
          <el-form-item label="数据范围">
            <el-select
              style="width: 100px"
              placeholder="记录类型"
              v-model="dataRangeType"
            >
              <el-option label="按月份" value="0"></el-option>
              <el-option label="全部" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经营月份" v-if="dataRangeType == '0'">
            <time-range :cache="false" timeType="month" @change="handleTimeChange" />
          </el-form-item>
          <el-form-item label="记录类型">
            <el-select
              style="width: 100px"
              placeholder="记录类型"
              v-model="batchExportModel.optSplit"
            >
              <el-option label="正常" value="0"></el-option>
              <el-option label="拆零" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="兽药类型">
            <el-select
              style="width: 120px"
              placeholder="兽药类型"
              v-model="batchExportModel.drugType"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="非处方药" value="非处方药"></el-option>
              <el-option label="处方药" value="处方药"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据类型">
            <el-select
              v-model="batchExportModel.dataType"
              style="width: 200px"
              placeholder="数据类型"
            >
              <el-option label="兽药销售记录" value="sale"></el-option>
              <el-option label="兽药采购记录" value="purchase"></el-option>
              <el-option label="兽药出库记录" value="outbound"></el-option>
              <el-option label="兽药入库记录" value="inbound"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批准文号">
            <el-input
              v-model="batchExportModel.approvalNum"
              placeholder="批准文号"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="hover">
      <div v-if="storeInfo">
        <div style="padding: 20px">
          <div style="float: right; margin-bottom: 20px">
            <el-button
              :loading="batchExportSubmit"
              @click="batchExportSubmitClick"
              type="primary"
            >
              {{ batchExportSubmit ? "正在导出中，请勿关闭界面" : `导出完整数据` }}
            </el-button>
          </div>
          <div class="vet-receipt-title">
            <span>{{ dataTypeLabel }}</span>
          </div>
          <vet-receipt-list :params="defaultParams" />
        </div>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="getDetail" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
    <el-dialog
      title="提示"
      append-to-body
      :show-close="false"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :visible="batchExportSubmit"
      width="400px"
    >
      <span>
        <i class="el-icon-loading"></i>
        正在导出数据中，请勿离开此页面
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
.vet-receipt-title {
  color: #919191;
  margin-bottom: 10px;
  font-size: 16px;
}
</style>

<script>
import timeRange from "../../../../components/timeRange.vue";
import vetReceiptList from "./__export_vet_receipt_list.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";

export default {
  components: {
    timeRange,
    vetReceiptList,
    customerStoreSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
    dataTypeLabel() {
      return this.batchExportModel.dataType == "inbound"
        ? "兽药入库记录表"
        : this.batchExportModel.dataType == "outbound"
        ? "兽药出库记录表"
        : this.batchExportModel.dataType == "purchase"
        ? "兽药采购记录表"
        : this.batchExportModel.dataType == "sale"
        ? "兽药销售记录表"
        : "兽药经营数据表";
    },
    defaultParams() {
      let typeProp =
        this.batchExportModel.dataType == "inbound"
          ? {
              bizType: "inbound",
            }
          : this.batchExportModel.dataType == "outbound"
          ? {
              bizType: "outbound",
            }
          : this.batchExportModel.dataType == "purchase"
          ? {
              bizType: "inbound",
            }
          : this.batchExportModel.dataType == "sale"
          ? {
              bizType: "outbound",
              receiptType: "order_sale",
            }
          : {};
      return Object.assign(
        {
          storeGuid: this.storeGuid,
          approvalNum: this.batchExportModel.approvalNum,
          dataType: this.batchExportModel.dataType,
          drugType: this.batchExportModel.drugType,
          optSplit: this.batchExportModel.optSplit,
          optCancel: "0",
        },
        this.dataRangeType == "0" ? this.times : {},
        typeProp
      );
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
      this.fetchStoreInfo();
    },
  },
  methods: {
    handleTimeChange(time) {
      this.times = time;
    },
    fetchStoreInfo() {
      if (this.storeGuid) {
        this.errorMsg = null;
        this.loading = true;
        this.requestApi(
          "biz.customer.store.info.detail",
          {
            guid: this.storeGuid,
          },
          {
            cache: 1,
            cacheCallback: (resp) => {
              this.loading = false;
              this.storeInfo = resp.data;
            },
          }
        )
          .then((resp) => {
            this.loading = false;
            this.storeInfo = resp.data;
          })
          .catch((err) => {
            this.loading = false;
            this.errorMsg =
              (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
          });
      } else {
        this.loading = false;
        this.errorMsg = null;
        this.storeInfo = null;
      }
    },
    batchExportSubmitClick() {
      this.batchExportSubmit = true;
      this.requestApi(
        "biz.warehouse.vet.receipt.export",
        Object.assign({}, this.defaultParams),
        { showError: true, download: true }
      ).finally(() => {
        this.batchExportSubmit = false;
      });
    },
  },
  data() {
    return {
      times: null,
      loading: false,
      errorMsg: null,
      storeGuid: "",
      storeInfo: null,
      batchExportModel: {
        drugType: "",
        dataType: "sale",
        optSplit: "0",
      },
      dataRangeType: "0",
      batchExportSubmit: false,
      batchExportRules: {},
    };
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
    this.fetchStoreInfo();
  },
};
</script>
